import { message } from "utilities/message";
import { err, ok } from "utilities/result";

const dismissAllNotifications = async () => {
  const [response, error] = await message("dismiss-all-notifications");

  if (error) {
    console.log("Could not dismiss all notifications", error);
    return err(error);
  }

  return ok(response);
};

const dismissNotification = async (id: string) => {
  const [response, error] = await message("dismiss-notification", { id });

  if (error) {
    console.error("Could not dismiss notification", id, error);
    return err(error);
  }
  return ok(response);
};

export const notificationsService = {
  dismissNotification,
  dismissAllNotifications,
};
